import { Middleware } from "@reduxjs/toolkit";
import { navigateTo, setUrlData, View } from "features/global/reducer";
import { RootState } from "./rootReducer";

// parse view from url
const viewByParam = Object.entries(View).map(([k, view]) => ({ param: k.toLowerCase(), view }));
const parseViewFromUrl = () => {
    const viewParam = window.location.hash.match(/#\/([^?/]*)/) || [];
    return viewByParam.find(({ param }) => param === viewParam[1]?.toLowerCase())?.view;
};

// parse url data from url
const parseDataFromUrl = () => {
    const urlData: { [x: string]: string } = {};
    const matches = window.location.hash.matchAll(/[?&]([^=]+)=([^&]*)/g);
    for (const [, key, value] of matches) {
        urlData[key] = value;
    }
    return urlData;
};

// router middleware
const router: Middleware<{}, RootState> = ({ dispatch, getState }) => {
    // create url from current state
    const createUrlFromState = () => {
        const { global } = getState();
        const view = global.view.toLowerCase();
        return `#/${view}`;
    };

    // try to infer view from url (later: add deep link support)
    const navigateByUrl = () => {
        // parse url data
        const urlData = parseDataFromUrl();
        if (Object.keys(urlData).length > 0) {
            dispatch(setUrlData(urlData));
        }

        // navigate to view
        const view = parseViewFromUrl();
        if (view && view !== getState().global.view) {
            dispatch(navigateTo(view));
        }

        // overwrite hash (clear invalid params)
        window.location.hash = createUrlFromState();
    };

    // listen to initial mount, hash changes
    window.addEventListener("load", navigateByUrl);
    window.addEventListener("hashchange", navigateByUrl);

    // update url when necessary
    return (next) => (action) => {
        const result = next(action);
        if (action.type === "global/navigateTo") {
            window.location.hash = createUrlFromState();
        }
        return result;
    };
};

export default router;
